module.exports = __webpack_public_path__ + "img/cns_printer_mac35.42e7c6e2.png";